// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./front/front.scss
// module id = 15
// module chunks = 1